define("ember-changeset-validations/validators/inclusion", ["exports", "ember-changeset-validations/utils/validation-errors", "ember-validators/inclusion"], function (_exports, _validationErrors, _inclusion) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = validateInclusion;
  0; //eaimeta@70e063a35619d71f0,"ember-changeset-validations/utils/validation-errors",0,"ember-validators/inclusion"eaimeta@70e063a35619d71f
  function validateInclusion() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (options.list) {
      options.in = options.list;
    }
    return (key, value) => {
      let result = (0, _inclusion.default)(value, options, null, key);
      return result === true ? true : (0, _validationErrors.default)(key, result);
    };
  }
});